import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import WordList from "./WordList";
import { useDrop } from "react-dnd";
import { urls } from "../../../../utils/urls";
import { replace } from "react-router-dom";

function Goal(props) {
  const [{ isOver }, goal] = useDrop(() => ({
    accept: ["word"],
    drop: (item) => props.addWordToGroup(item.id, props.id, props.x),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  console.log(props.image.replace('/api',''))

  return (
    <>
      <Col
        style={{
          height: "308px",
          width: "314px",
          margin: "3px",
        }}
        key={props.x}
      >
        <div
          ref={(ref) => (props.goalRef[props.x] = ref)}
          style={{
            borderRadius: "25px",
            height: "312px",
            width: "322px",
            padding: "2px",
            margin: "2px",
          }}
        >
          {//this is the border around the goal
          }
          <div
            ref={goal}
            style={{
              borderRadius: "25px",
              height: "304px",
              width: "314px",
              margin: "2px",
              border: isOver ? "2px solid #FFC107" : "blue 2px solid",
            }}
            key={props.id}
          >
            <img
              key={Math.random()}
              style={{
                height: "300px",
                width: "310px",
                borderRadius: "22px",
              }}
              src={urls.BASE_API_URL + props.image.replace('/api','')}
            ></img>
          </div>
        </div>
      </Col>
    </>
  );
}

export default Goal;
